<navbar/>
<div class="dashboard-container glassy-bg jobs-advertised-page p-3">
    <div class="ms-2">
        <NavigationBackButton />
    </div>
  <div class="jobs-content">

      <!-- Company First Card -->
      <div class="shadow-lg rounded-lg position-relative" 
        :class="{
          'dwypd-opps-bg': hostname.includes('recruitment.dwypd.gov') || hostname.includes('dwypd.complyon'),
          
        }">
        
        <!-- Hero Section -->
        <section class="hero-section d-flex justify-content-center align-items-center text-center min-h-200">
          <div class="col-md-6 col-lg-5">
            <h5 class="text-white fw-bold fst-italic">Explore New Career Opportunities</h5>
            <h6 class="mt-1 text-white">
              Browse the latest job posts and take the next step in your professional journey.
            </h6>
          </div>
        </section>

      </div>

      <!-- FILTER SECTION -->
      <section>
  <div class="search-wrap position-relative">
    <span class="position-absolute top-50 translate-middle-y ms-3 text-secondary d-flex align-items-center" style="pointer-events:none;">
      <i class="bi bi-search" style="font-size:14px;"></i>
    </span>
    <input
      v-model="filters.search"
      type="text"
      class="form-control search-input ps-5 pe-5"
      placeholder="Search by job title or reference #"
      @input="on_filter_change"
    />
    <button
      v-if="filters.search"
      type="button"
      class="position-absolute top-50 translate-middle-y end-0 me-3 border-0 bg-transparent d-flex align-items-center text-secondary"
      @click="filters.search = ''; on_filter_change()"
    >
      <i class="bi bi-x" style="font-size:18px;"></i>
    </button>
  </div>
</section>

      <!-- Job Listings -->
      <section>
        <div class="row row-cols-1 row-cols-md-2 g-3">
        <div v-for="(job, index) in paginated_jobs"
             :key="job.id || `job-${index}`"
             class="col">

          <div class="glassy-table h-100 shadow-lg rounded-lg p-3 d-flex flex-column gap-1">
            <div class="d-flex align-items-start gap-1">
              <div class="d-flex align-items-center justify-content-center job-icon p-1 flex-shrink-0">
                <i class="bi bi-briefcase-fill fs-5 rounded-lg briefcase-green-icon"></i>
              </div>

              <div class="flex-grow-1">
                <div class="d-flex justify-content-between align-items-start gap-1 mb-1">
                  <span class="fw-bold fw-600 text-x pe-2">{{ job.jobTitle }}</span>
                  <span class="status-badge text-dark fw-bold flex-shrink-0 border-0"
                    :class="get_status_badge_class(job.status)">
                    {{ job.status }}
                  </span>
                </div>

                <p class="text-dark text-xs mb-1" v-if="job.referenceNumber && job.referenceNumber !== '-'">
                  <span class="fw-600">Ref :</span> {{ job.referenceNumber }}
                </p>

                <div class="text-dark text-xs d-flex flex-column gap-1">
                  <p class="mb-0">
                    <i class="bi bi-calendar-event me-1"></i>
                    <span v-if="job.publishedDate" class="fw-600"><span class="fw-bold">Opens :</span> {{ format_display_datetime(job.publishedDate) }}</span>
                    <span v-else>Opens : TBD</span>
                  </p>
                  <p class="mb-0">
                    <i class="bi bi-calendar-check me-1"></i>
                    <span v-if="job.closingDate" class="fw-600"><span class="fw-bold">Closes :</span> {{ format_display_datetime(job.closingDate) }}</span>
                    <span v-else>Open-ended</span>
                  </p>
                </div>

                <div class="d-flex justify-content-end mt-1">
                  <button
                    class="btn btn-primary btn-sm text-xxs"
                    data-bs-toggle="modal"
                    data-bs-target="#job-details-modal"
                    @click="open_job_details(job)"
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </section>

      <!-- Pagination -->
      <div v-if="total_pages > 1" class="d-flex justify-content-center align-items-center mt-4 mb-3">
      <div class="d-flex gap-1">
        <button
          class="btn-primary-dark rounded btn-sm text-x view-details-btn"
          :disabled="current_page === 1"
          @click="go_to_page(current_page - 1)"
        >
          &lt;
        </button>
        <button
          class="btn-primary-dark rounded btn-sm text-x view-details-btn"
          :disabled="current_page === total_pages"
          @click="go_to_page(current_page + 1)"
        >
          &gt;
        </button>
      </div>
      </div>

    </div>
  <AICampusFooter />
</div>

<!-- Job Details Modal -->
<teleport to="body">
  <div class="modal fade" id="job-details-modal" tabindex="-1" aria-labelledby="job_details_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">

        <!-- Modal Header (cute-header like manage_questions) -->
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <div class="flex-grow-1">
            <p class="modal-title text-white text-xxs mb-0" id="job_details_label">{{ job_profile.title || job.title }}</p>
            <small class="text-white-50 text-xxs d-flex align-items-center flex-wrap gap-1" v-if="job.publishedDate || job.closingDate">
              <i class="bi bi-calendar-event"></i>
              <span v-if="job.publishedDate">{{ format_display_datetime(job.publishedDate) }}</span>
              <span v-else>TBD</span>
              <span class="mx-1">to</span>
              <i class="bi bi-calendar-event"></i>
              <span v-if="job.closingDate">{{ format_display_datetime(job.closingDate) }}</span>
              <span v-else>Open-ended</span>
            </small>
          </div>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Modal Body (scrollable) -->
        <div class="modal-body p-4">

          <!-- Loading State -->
          <div v-if="loading_profile" class="text-center py-5">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-3 text-muted text-xxs">Loading job profile...</p>
          </div>

          <!-- Loaded Content (mirrors ViewJobProfile VIEW mode) -->
          <div v-else-if="job_profile.display_blocks && job_profile.display_blocks.length">

            <div v-for="(block, bidx) in job_profile.display_blocks"
                 :key="block.key || bidx"
                 class="job-detail-block"
                 :class="{ 'ps-3 ms-2 border-start': block.depth > 0 }">
              <div class="d-flex align-items-center mb-3">
                <span class="badge bg-green-gov-dark rounded-50 me-2 d-flex align-items-center justify-content-center circle-badge-28">
                  {{ section_badge_label(block.title) }}
                </span>
                <h6 class="fw-bold mb-0 text-xs">
                  <span v-if="block.depth > 0" class="text-muted me-1">Sub-section:</span>{{ section_display_title(block.title) }}
                </h6>
              </div>

              <div v-if="block.kind === 'details'" class="text-xxs text-dark rich-text-content job-detail-content">
                <component :is="parse_plain_text_list(block.data)?.tag || 'div'"
                           v-if="parse_plain_text_list(block.data)"
                           class="job-detail-list">
                  <li v-for="(item, idx) in parse_plain_text_list(block.data).items"
                      :key="'bdl-'+idx">
                    {{ item }}
                  </li>
                </component>
                <div v-else v-html="render_block_html(block, block.data)"></div>
              </div>

              <template v-else>
                <div v-if="block.data.table && block.data.table.rows && block.data.table.rows.length > 0 && has_table_content(block.data)"
                     class="table-responsive mb-3">
                  <table class="table table-bordered table-hover table-sm align-middle">
                    <thead class="table-light">
                      <tr>
                        <th v-for="(hdr, hIdx) in block.data.table.headers"
                            :key="'mh-'+hIdx"
                            class="fw-semibold text-xxs text-uppercase">
                          {{ typeof hdr === 'object' ? hdr.label : hdr }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, rIdx) in block.data.table.rows" :key="'mr-'+rIdx">
                        <td v-for="(cell, cIdx) in row"
                            :key="'mc-'+cIdx"
                            class="text-xxs rich-text-content job-detail-content">
                          <component :is="parse_plain_text_list(cell)?.tag || 'div'"
                                     v-if="parse_plain_text_list(cell)"
                                     class="job-detail-list">
                            <li v-for="(item, idx) in parse_plain_text_list(cell).items"
                                :key="'mcl-'+rIdx+'-'+cIdx+'-'+idx">
                              {{ item }}
                            </li>
                          </component>
                          <div v-else v-html="render_block_html(block, cell)"></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-else-if="is_competencies_block(block) && block.data.descriptions && block.data.descriptions.length">
                  <div v-for="(desc, dIdx) in block.data.descriptions"
                       :key="'mcg-'+dIdx"
                       class="mb-2 text-xxs text-dark rich-text-content job-detail-content">
                    <template v-if="parse_competency_groups(desc).length">
                      <div v-for="(group, gIdx) in parse_competency_groups(desc)"
                           :key="'mcgg-'+dIdx+'-'+gIdx"
                           class="competency-group">
                        <p class="competency-line"><strong>{{ group.label }}:</strong></p>
                        <ul v-if="group.items.length > 1" class="competency-list">
                          <li v-for="(item, iIdx) in group.items"
                              :key="'mcgi-'+dIdx+'-'+gIdx+'-'+iIdx">
                            {{ item }}
                          </li>
                        </ul>
                        <p v-else class="competency-line">{{ group.value }}</p>
                      </div>
                    </template>
                    <component :is="parse_plain_text_list(desc)?.tag || 'div'"
                               v-else-if="parse_plain_text_list(desc)"
                               class="job-detail-list">
                      <li v-for="(item, idx) in parse_plain_text_list(desc).items"
                          :key="'mcdl-'+dIdx+'-'+idx">
                        {{ item }}
                      </li>
                    </component>
                    <div v-else v-html="render_block_html(block, desc)"></div>
                  </div>
                </div>

                <div v-else-if="block.data.descriptions && block.data.descriptions.length">
                  <div v-for="(desc, dIdx) in block.data.descriptions"
                       :key="'md-'+dIdx"
                       class="mb-2 text-xxs text-dark rich-text-content job-detail-content">
                    <component :is="parse_plain_text_list(desc)?.tag || 'div'"
                               v-if="parse_plain_text_list(desc)"
                               class="job-detail-list">
                      <li v-for="(item, idx) in parse_plain_text_list(desc).items"
                          :key="'mdl-'+dIdx+'-'+idx">
                        {{ item }}
                      </li>
                    </component>
                    <div v-else v-html="render_block_html(block, desc)"></div>
                  </div>
                </div>

                <div v-else-if="block.data.content" class="text-xxs text-dark rich-text-content job-detail-content">
                  <component :is="parse_plain_text_list(block.data.content)?.tag || 'div'"
                             v-if="parse_plain_text_list(block.data.content)"
                             class="job-detail-list">
                    <li v-for="(item, idx) in parse_plain_text_list(block.data.content).items"
                        :key="'mct-'+idx">
                      {{ item }}
                    </li>
                  </component>
                  <div v-else v-html="render_block_html(block, block.data.content)"></div>
                </div>

                <div v-if="block.data.subsections && block.data.subsections.length" class="mt-3 ps-3 border-start">
                  <div v-for="(subsection, subIdx) in block.data.subsections"
                       :key="'job-sub-'+subIdx"
                       v-show="subsection.show_on_advert !== false"
                       class="mb-3 p-3 bg-light rounded-3">
                    <h6 class="fw-semibold mb-2 text-xs">
                      {{ subsection.title || ('Sub-section ' + (subIdx + 1)) }}
                    </h6>

                    <div v-if="subsection.table && subsection.table.rows && subsection.table.rows.length > 0 && has_table_content(subsection)"
                         class="table-responsive mb-2">
                      <table class="table table-bordered table-hover table-sm align-middle">
                        <thead class="table-light">
                          <tr>
                            <th v-for="(hdr, hIdx) in subsection.table.headers"
                                :key="'msh-'+hIdx"
                                class="fw-semibold text-xxs text-uppercase">
                              {{ typeof hdr === 'object' ? hdr.label : hdr }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, rIdx) in subsection.table.rows" :key="'msr-'+rIdx">
                            <td v-for="(cell, cIdx) in row"
                                :key="'msc-'+cIdx"
                                class="text-xxs rich-text-content job-detail-content">
                              <div v-html="render_block_html(block, cell)"></div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-else-if="subsection.descriptions && subsection.descriptions.length">
                      <div v-for="(desc, dIdx) in subsection.descriptions"
                           :key="'msd-'+dIdx"
                           class="mb-2 text-xxs text-dark rich-text-content job-detail-content">
                        <div v-html="render_block_html(block, desc)"></div>
                      </div>
                    </div>

                    <div v-else-if="subsection.content" class="text-xxs text-dark rich-text-content job-detail-content">
                      <div v-html="render_block_html(block, subsection.content)"></div>
                    </div>
                  </div>
                </div>
              </template>
            </div>

          </div>

          <!-- Fallback: No profile data -->
          <div v-else class="text-center py-5">
            <i class="bi bi-file-earmark-x fs-1 text-muted mb-3 d-block"></i>
            <p class="text-muted text-xxs mb-0">No advert data available for this position.</p>
          </div>

        </div>

        <!-- Modal Footer -->
        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark px-3"
            :disabled="job.status === 'Closed'"
            @click="applyForJob"
          >
            {{ job.status === 'Closed' ? 'Closed' : 'Apply' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>
